export default {
  "LocationCheckContents.Title": "ご自身の位置情報利用の同意状況",
  "LocationCheckContents.Text1": "【同意状況の変更をご希望の場合】",
  "LocationCheckContents.Text2":
    "上記「位置情報をドコモおよびNTTドコモビジネス株式会社が利用することに同意」をタップして変更してください",
  "LocationCheckContents.Text3":
    "{asterisk}設定にかかわらず、サービス・商品等の提供に必要な場合は利用します",
  "LocationCheckContents.DetailsLinkText1": "位置情報とは",
  "LocationCheckContents.DetailsLinkText2": "詳しくはこちら",
}
